import { jsx as _jsx, jsxs as _jsxs } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { BlockWrapper } from '../../ui-kit/BlockWrapper.js';
import { Img } from '../../ui-kit/Img/Img.js';
import { LinkButton } from '../../ui-kit/LinkButton/LinkButton.js';
import { style } from '../../utils/style.js';
import { Headline } from '../Headline/Headline.js';
const renderErrorContent = (error) => {
    if (error?.contentType === 'Image' && error?.image) {
        return _jsx(Img, { image: error.image });
    }
    if (error?.contentType === 'Code' && error.code) {
        return (_jsx("div", { className: "font-mohave text-title-large sm:text-title-extra gradient-color-text", children: error.code }));
    }
    return null;
};
export const ErrorBlock = JSX(({ className = '', title, description, error, button, ...rest }) => (_jsxs(BlockWrapper, { className: style('flex flex-col justify-center items-center', className), defaultPadding: style('p-6xl'), version: "transparent", ...rest, children: [_jsx("div", { className: "flex justify-center", children: renderErrorContent(error) }), _jsx(Headline, { title: title, description: description, headlineVersion: "XL", isEmbedded: true, className: "mb-2xl last:mb-0" }), button?.text ? (_jsx(LinkButton, { version: button?.version, text: button?.text, ...button })) : null] })));
//# sourceMappingURL=ErrorBlock.js.map